import type {CSSProperties} from 'react';

export type WedgeBv2TabCardLook = 'bv2tab-copy';

const BV2_TAB_CARD_LOOKS = new Set<string>(['bv2tab-copy']);
export const isWedgeBv2TabCardLook = (look: string | undefined): look is WedgeBv2TabCardLook => look !== undefined && BV2_TAB_CARD_LOOKS.has(look);

/* Released brief v2 tab copy button (prep-brief-v2-tabs, Bv2tCopyButton). It is a 44px square with a 9px radius, an inline icon centered
   in a flex box. The fill, the border, the ink and the transition depend on the copied state and on reduced motion, and the tab paints
   them from its two-theme palette, so the caller passes them as style. This look holds the geometry only, in the declaration order of the
   source. It draws no transparent target and no anchor (wedgeBv2TabCardDrawsHit): its own box already meets the 44px target size. */
export const wedgeBv2TabCardDrawsHit = (look: string): boolean => !isWedgeBv2TabCardLook(look);

export function wedgeBv2TabCardStyle(look: WedgeBv2TabCardLook): CSSProperties {
  switch (look) {
    case 'bv2tab-copy': return {
      width: 44, height: 44, borderRadius: 9, flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
    };
  }
}
